import { render, staticRenderFns } from "./HandleDialog.vue?vue&type=template&id=3ae89c4d&"
import script from "./HandleDialog.vue?vue&type=script&lang=js&"
export * from "./HandleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports